import { atom } from "nanostores";
import { $touchMode } from "./touch";

const KEY = "nomen.gyro";

/** Whether turning the phone turns the view: on unless this device switched it off in settings. */
export const $gyroOn = atom(true);

/** What a refused iOS motion permission tells the player. */
export const GYRO_DENIED = "陀螺儀沒有連上：到設定把「陀螺儀轉視角」關掉再打開，就能重新允許";

export function initGyro(): void {
  try { $gyroOn.set(localStorage.getItem(KEY) !== "0"); } catch { $gyroOn.set(true); }
}

export function setGyro(on: boolean): void {
  $gyroOn.set(on);
  try { if (on) localStorage.removeItem(KEY); else localStorage.setItem(KEY, "0"); } catch { /* blocked storage: this visit only */ }
}

/** The gyro steers only in touch mode, switched on, with the page in view; a panel or the chat blocks it in InputState. */
export function gyroActive(visibility: DocumentVisibilityState = document.visibilityState): boolean {
  return $gyroOn.get() && $touchMode.get() && visibility !== "hidden";
}
